import React, { Component } from 'react';

require('../../../sass/components/spinner.scss');

export default class Spinner  extends Component {

    constructor(props){
        super(props);
    }

    render(){
        let SpinnerComponent
        = (
            <div className="spinner-container">
                <div className="loader">
                    <svg className="circular">
                        <circle
                            className        = "path"
                            cx               = "50"
                            cy               = "50"
                            r                = "20"
                            fill             = "none"
                            strokeWidth      = "3"
                            strokeMiterlimit = "10"
                        />
                    </svg>
                </div>
            </div>
        );
        return SpinnerComponent ;
    }
}




// WEBPACK FOOTER //
// src/components/generic/spinner.js